import React from 'react'

import Navbar from '../Components/Navbar'
import PumpsPageImages from '../Components/PumpsPageImages'
import Footer from '../Components/Footer'

const Pumps = () => {
  return (
    <div>
      <Navbar />
      <PumpsPageImages />
      <Footer />
    </div>
  )
}

export default Pumps